import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-8" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-md bg-white border border-[#E6E6E6] flex items-center justify-center p-1">
            <img src="/logo.png" alt="SportsUnity" className="w-full h-full object-contain" />
          </div>
          <span className="text-lg font-semibold text-[#074572]" style={{ fontFamily: 'Outfit' }}>SportsUnity</span>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="w-14 h-14 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail size={24} className="text-green-600" />
            </div>
            <h1 className="text-2xl font-medium text-zinc-900 mb-2" style={{ fontFamily: 'Outfit' }}>Check Your Email</h1>
            <p className="text-sm text-zinc-500 mb-6">If an account exists for {email}, we've sent a password reset link.</p>
            <Link to="/login">
              <Button variant="outline" className="border-[#E6E6E6] text-[#074572]">Back to Login</Button>
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-medium text-zinc-900 mb-1" style={{ fontFamily: 'Outfit' }}>Forgot password?</h1>
            <p className="text-sm text-zinc-500 mb-8">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-zinc-700">Email</Label>
                <Input id="email" type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 border-[#E6E6E6]" data-testid="forgot-email-input" required />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#F85037] hover:bg-[#e04530] text-white h-10" data-testid="forgot-submit-btn">
                {loading ? "Sending..." : "Send Reset Link"}
              </Button>
            </form>
            <p className="text-sm text-zinc-500 text-center mt-6">
              Remember your password? <Link to="/login" className="text-[#074572] font-medium hover:underline">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
